import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-date-time-picker";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
class ConfigurationItemPurchaseTab {
    Bao = Bao;
    InventoryNumber = ko.observable();
    OrderNumber = ko.observable();
    OrderDateJS = ko.observable();
    StoringPositionNumber = ko.observable();
    PurchaseRequisitionDateJS = ko.observable();
    PurchaseRequisitionNumber = ko.observable();
    ImpersonalAccount = ko.observable();
    AccountAssignment = ko.observable();
    AccountAssignmentTypeId = ko.observable();
    AccountAssignmentTypeName = ko.observable();
    PurchaseVendorId = ko.observable();
    PurchaseVendorName = ko.observable();
    PurchaseTypeId = ko.observable();
    PurchaseTypeName = ko.observable();
    PurchaseExternalSupporterId = ko.observable();
    PurchaseExternalSupporterName = ko.observable();
    Loading = ko.observable<boolean>(false);
    constructor(public TabPage: TabPage, public Parent) {
        this.TabPage.DirtyFlag.subscribe((isDirty) => {
            if (isDirty) {
                this.Parent.TabPage.DirtyFlag(true);
            }
        });
    }
    CompleteCheck() {
        var def = $.Deferred();
        def.resolve(true);
        return def.promise();
    }
    Refresh() {
        this.Loading(true);
        this.TabPage.IsLoading(true);
        return Bao.post("ConfigurationItemPurchaseTab/Get", JSON.stringify({
            id: this.Parent.ConfigurationItemId(),
        }), (result) => {
            if (result != null) {
                ko.map.fromJS(result, this, this.TabPage.DirtyFlag);
            }
            this.Loading(false);
            this.TabPage.IsLoading(false);
        });
    }
    Save(saveTime) {
        this.Loading(true);
        this.TabPage.IsLoading(true);
        return Bao.post("ConfigurationItemPurchaseTab/Save", JSON.stringify({
            saveTime: saveTime,
            model: ko.map.toJS(this)
        }), (result) => {
            this.Loading(false);
            this.TabPage.DirtyFlag(false);
            this.TabPage.IsLoading(false);
        });
    }
    init() {
    }
    loaded() {
        return this.Refresh();
    }
    ;
}
export default ConfigurationItemPurchaseTab;